import { createContext, useContext, useMemo, useState } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import buildTheme from '../theme';

const ColorModeContext = createContext({ mode: 'light', alternar: () => {} });

export const useColorMode = () => useContext(ColorModeContext);

const MODE_KEY = 'patio_theme_mode';

// Alternância claro/escuro sem recarregar a página, com persistência.
export const ColorModeProvider = ({ children }) => {
    const [mode, setMode] = useState(() => localStorage.getItem(MODE_KEY) === 'dark' ? 'dark' : 'light');

    const contexto = useMemo(() => ({
        mode,
        alternar: () => setMode((atual) => {
            const novo = atual === 'light' ? 'dark' : 'light';
            localStorage.setItem(MODE_KEY, novo);
            return novo;
        }),
    }), [mode]);

    const theme = useMemo(() => buildTheme(mode), [mode]);

    return (
        <ColorModeContext.Provider value={contexto}>
            <ThemeProvider theme={theme}>
                <CssBaseline />
                {children}
            </ThemeProvider>
        </ColorModeContext.Provider>
    );
};
